(ns frontend.actions.login
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]))

(defn *<-toggle-sandbox
  [data on-success! on-error!]
  (-> (conn/sendp! :login/toggle-sandbox data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *<-get-roles
  [data on-success! on-error!]
  (-> (conn/sendp! :login/get-roles data 60000 true)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->change-password
  [data on-success! on-error!]
  (-> (conn/sendp! :login/change-password data 15000)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->check-token-validity
  [data on-success! on-error!]
  (-> (conn/sendp! :login/check-token-validity data 10000 true)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->send-reset-password-email
  [data on-success! on-error!]
  (-> (conn/sendp! :login/send-reset-password-email
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *<-set-role
  [data on-success! on-error!]
  (-> (conn/sendp! :login/set-role data 10000 true)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *<-validate-token
  [data on-success! on-error!]
  (-> (conn/sendp! :login/validate-token data 10000 true)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *<-validate-authentication
  [data on-success! on-error!]
  (-> (conn/sendp! :login/validate-authentication data 10000 true)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *<-login-with-token
  [data on-success! on-error!]
  (-> (conn/sendp! :login/login-with-token data 10000 true)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *<-get-linkedin-url
  [data on-success! on-error!]
  (-> (conn/sendp! :login/get-linkedin-url
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *<-linkedin-callback
  [data on-success! on-error!]
  (-> (conn/sendp! :login/linkedin-callback
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *>-setup-mfa
  [data on-success! on-error!]
  (-> (conn/sendp! :login/setup-mfa data 10000 true)
      (p/then on-success!)
      (p/catch on-error!)))
